import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import API from '../../../../create/api';

interface PhoneNumberInputProps {
  phoneNumber: string | null;
  setPhoneNumber: (phone: string) => void;
  setCustomerName: (name: string) => void;
  setAddress: (address: string) => void;
  setRider: (rider: string) => void;
  setArea: (area: string) => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  phoneNumber,
  setPhoneNumber,
  setCustomerName,
  setAddress,
  setRider,
  setArea,
}) => {
  const [phoneOptions, setPhoneOptions] = useState<
    { phone: string; name: string; address: string; rider: string; area: string; key: string }[]
  >([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (inputValue.length >= 5) {
      API.getAll(`${process.env.REACT_APP_API_SERVER}/phone-options?query=${inputValue}`)
        .then((response: any) => {
          setPhoneOptions(
            response.map((item: any) => ({
              ...item,
              key: `${item.phone}-${item.name}`, // Ensure uniqueness
            })),
          );
        })
        .catch((error) => {
          console.error('Error fetching phone options:', error);
        });
    }
  }, [inputValue]);

  const isValidMobileNo = (mobile_no: string | null): boolean => {
    if (!mobile_no) return true;

    const isValidNumber = (num: string) => num.length === 11 && /^01\d+$/.test(num);

    const numbers = mobile_no.split(',').map((num) => num.trim());
    return numbers.every((num) => num.length === 0 || isValidNumber(num));
  };

  return (
    <Autocomplete
      freeSolo
      options={phoneOptions}
      getOptionLabel={(option) => (typeof option === 'string' ? option : `${option.phone} - ${option.name}`)}
      renderInput={(params) => (
        <TextField
          {...params}
          error={!isValidMobileNo(phoneNumber)}
          helperText={!isValidMobileNo(phoneNumber) ? 'Invalid Number' : ''}
          variant="standard"
          fullWidth
          label="Mobile*"
        />
      )}
      onInputChange={(event, newInputValue) => {
        if (newInputValue.length < 5) {
          setPhoneOptions([]);
        }
        setInputValue(newInputValue);
        setPhoneNumber(newInputValue);
      }}
      onChange={(event, newValue) => {
        if (typeof newValue === 'object' && newValue !== null) {
          setPhoneNumber(newValue.phone);
          setCustomerName(newValue.name);
          setAddress(newValue.address);
          setRider(newValue.rider);
          setArea(newValue.area);
        } else {
          setPhoneNumber(inputValue);
        }
      }}
      value={phoneNumber || ''}
    />
  );
};

export default PhoneNumberInput;
